module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("FVoN6"))).then(() => parcelRequire('fThBo'));